import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DashboardServiceService {

  constructor(private http: HttpClient) { }

  searchUsuario(){
    //return this.http.get<infoUsuario>('http://localhost:53351/Usuario/GetInformacionUsuario');
    return this.http.get<infoUsuario>('/api/Usuario/GetInformacionUsuario');

  }

}

export interface infoUsuario {
  iIDUsuario?: number;
  iIDSubTablaTipoDoc?: number | null;
  tIDValorTipoDoc?: string;
  tNumDoc?: string;
  tUsuario?: string;
  tPrimerNombre?: string;
  tSegundoNombre?: string;
  tPrimerApellido?: string;
  tSegundoApellido?: string;
  tClave?: string;
  tTelefono?: string;
  tCelular?: string;
  tEmail?: string;
  bActivo?: boolean;
  bHabilitado?: boolean;
  dtFechaModificacion?: Date | null;
  iIDUsuarioCreador?: number;
  dtFechaCreacion?: Date;
  iIDSubTablaGenero?: number | null;
  tIDValorGenero?: string;
  iIDDivipola?: number | null;
  dtFechaCambioPassword: Date;
  bCambioPassword?: boolean;
  iIDIdioma?: number | null;
  vSignature?: Uint8Array | null;
  tClaveFirmaDigital?: string;
  tTokenCambioClave?: string;
  iIDEntidadDefecto?: number | null;
  dtVigenciaPassword?: Date | null;
  iFallidosLogin?: number | null;
  iAlertaVencimientoContrasena?: number | null;
}
